/* global $ */

define(['jquery', 'globalVars'], ($, { $body, $document }) => {
    return {
        init() {
            this.initEvents();
            this.initElements();
            // this.fixMobileHeaderRender(); // check after header is done
        },

        initEvents() {
            $document.on(
                'input change keydown update-status',
                '.form__input, .form__textarea',
                ev => {
                    const $element = $(ev.target);

                    $element.val().length > 0
                        ? $element.removeClass('_empty')
                        : $element.addClass('_empty');

                    if ($element[0].id === 'telephone' && ev.keyCode === 13) {
                        ev.preventDefault();

                        return false;
                    }

                    if ($element.hasClass('js-counter-inited')) {
                        $element
                            .parent()
                            .find('.js-current-length')
                            .text(String($element.val().length));
                    }
                }
            );

            $document.on('change', '.form__select', ev => {
                const $element = $(ev.target);
                const $parent = $element.parent();
                const valueElement = $element.val().length > 0;

                $parent.toggleClass('_empty', !valueElement);
            });

            $document.on('change', '.select', ev => {
                const $element = $(ev.target);

                $element.val()
                    ? $element.removeClass('_empty')
                    : $element.addClass('_empty');
            });

            $document.on('focus', '.form__textarea', ev => {
                const $element = $(ev.target);

                $element.parent().addClass('_focus');
            });

            $document.on('blur', '.form__textarea', ev => {
                const $element = $(ev.target);

                $element.parent().removeClass('_focus');
            });

            $body.on('btn-loader:start', this.startBtnLoader);
            $body.on('btn-loader:finish', this.finishBtnLoader);
        },

        initElements() {
            $('.form__textarea, .form__input').each((index, element) => {
                const $element = $(element);

                if ($element.val().length === 0) {
                    $element.addClass('_empty');
                }

                if (
                    $element.hasClass('_counter') &&
                    !$element.hasClass('js-counter-inited')
                ) {
                    this.initCounter($element);
                }

                if (
                    $element.hasClass('_resizable') &&
                    !$element.hasClass('js-resizer-inited')
                ) {
                    this.initResizer($element);
                }

                if (
                    $element.hasClass('form__textarea') &&
                    !$element.hasClass('js-textarea-inited')
                ) {
                    $element.addClass('js-textarea-inited');
                }
            });

            $('.form__select').each((index, element) => {
                const $element = $(element);
                const $parent = $element.parent();

                if (!$element.val()) {
                    $parent.addClass('_empty');
                }
            });

            $('.select').each((index, element) => {
                const $element = $(element);

                if (!$element.val()) {
                    $element.addClass('_empty');
                }
            });

            $('.form__checkbox, .form__radio').each((index, element) => {
                const $element = $(element);
                const $parent = $element.parent();

                if ($parent.hasClass('form__cell')) {
                    $parent.addClass('_checkable');
                }
            });

            $body.trigger('update_fancybox');
        },

        initCounter($element) {
            $element.parent().append(
                `<div class="form__counter js-counter">
                    <span class="js-current-length">0</span> / <span class="js-max-length">0</span>
                </div>`
            );

            const $counter = $element.parent().find('.js-counter');
            const $currentLength = $counter.find('.js-current-length');
            const $maxLength = $counter.find('.js-max-length');

            $currentLength.text(String($element.val().length));
            $maxLength.text($element.attr('maxlength'));

            $element.addClass('js-counter-inited');
        },

        getResizeHandler($element) {
            function resizeHandler(ev) {
                const textareaRect = $element[0].getClientRects();
                const textareaNewHeight = ev.clientY - textareaRect[0].y;

                if (textareaNewHeight < 0) {
                    return;
                }

                $element.css('height', `${textareaNewHeight}px`);
            }

            return resizeHandler;
        },

        initResizer($element) {
            $element
                .parent()
                .addClass('_resizable')
                .append(
                    '<div class="form__resize-handle js-resize-handle"></div>'
                );

            const $resizeHandle = $element.parent().find('.js-resize-handle');
            const resizeHandler = this.getResizeHandler($element);

            $resizeHandle.on('mousedown touchstart pointerdown', () => {
                $document.on(
                    'mousemove.textarea touchmove.textarea pointermove.textarea',
                    resizeHandler
                );
                $document.one('mouseup touchend pointerup', () => {
                    $document.off(
                        'mousemove.textarea touchmove.textarea pointermove.textarea',
                        resizeHandler
                    );
                });
            });

            $element.addClass('js-resizer-inited');
        },

        fixMobileHeaderRender() {
            if (!$body.hasClass('mobile')) {
                return;
            }

            $document.on('focus', '.form__textarea', () => {
                $('.js-header').css('position', 'absolute');
            });

            $document.on('blur', '.form__textarea', () => {
                $('.js-header').css('position', 'fixed');
            });
        },

        startBtnLoader(e, el, color) {
            $(el)
                .addClass('_loader')
                .append(`<span class="btn-loader _${color}"></span>`);
        },

        finishBtnLoader(e, el) {
            $(el).find('.btn-loader').remove();
            $(el).removeClass('_loader');
        },
    };
});
